var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g2, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _g3, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _g4, _path145, _path146, _g5, _path147, _g6, _path148, _path149, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommercialBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 500,
    viewBox: "0 0 814 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1313 92.1907L70.4045 98.0139L64.5848 110.295",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7945 185.758C14.068 168.106 16.0702 148.649 25.9241 131.572C35.778 114.494 51.6159 103.031 69.2568 98.3003",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94287 320.086L19.1191 312.361L26.8376 323.544",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2568 400.958C51.6159 396.228 35.7767 384.763 25.9241 367.686C16.0702 350.609 14.068 331.153 18.7945 313.5",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M755.867 407.068L743.594 401.245L749.413 388.964",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M795.204 313.501C799.93 331.152 797.928 350.609 788.074 367.687C778.221 384.764 762.383 396.228 744.742 400.958",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M806.056 179.173L794.88 186.898L787.161 175.715",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M744.742 98.3018C762.383 103.031 778.222 114.496 788.075 131.573C797.928 148.651 799.931 168.106 795.204 185.759",
    stroke: "#7D8FD8",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M544.096 151.434C536.602 133.704 525.874 117.783 512.211 104.111C498.548 90.4403 482.636 79.7058 464.918 72.2068C446.57 64.4412 427.083 60.5042 407 60.5042C386.916 60.5042 367.428 64.4412 349.081 72.2068C331.363 79.7058 315.451 90.4403 301.788 104.111C288.125 117.783 277.397 133.705 269.903 151.434C262.142 169.793 258.208 189.291 258.208 209.388C258.208 229.484 262.142 248.983 269.903 267.341C277.397 285.072 288.125 300.993 301.788 314.664C315.451 328.335 331.363 339.069 349.081 346.568C367.43 354.334 386.916 358.271 407 358.271C427.083 358.271 446.571 354.334 464.918 346.568C482.636 339.069 498.548 328.335 512.211 314.664C525.874 300.993 536.602 285.072 544.096 267.341C551.857 248.982 555.792 229.484 555.792 209.388C555.792 189.291 551.857 169.792 544.096 151.434ZM413.025 165.16C434.401 164.644 454.863 161.374 473.932 155.417C476.185 154.713 478.406 153.972 480.597 153.196C484.801 168.848 487.21 185.8 487.66 203.358H413.023L413.025 165.16ZM413.025 153.095V72.9443C431.787 75.3277 449.418 88.807 463.204 111.505C468.712 120.571 473.355 130.695 477.071 141.601C457.788 148.459 435.789 152.488 413.025 153.095ZM400.974 72.9456V153.096C378.21 152.489 356.212 148.46 336.927 141.603C340.643 130.696 345.286 120.572 350.794 111.506C364.58 88.8082 382.212 75.3289 400.974 72.9456ZM340.066 155.417C359.135 161.374 379.597 164.643 400.973 165.16V203.358H326.337C326.788 185.802 329.197 168.848 333.399 153.196C335.593 153.972 337.814 154.714 340.066 155.417ZM314.285 203.358H270.394C271.528 177.304 279.977 153.116 293.736 132.807C302.038 138.854 311.621 144.24 322.131 148.78C317.433 165.816 314.752 184.273 314.285 203.358ZM314.285 215.416C314.752 234.501 317.434 252.958 322.13 269.994C311.62 274.534 302.037 279.92 293.735 285.967C279.976 265.658 271.527 241.472 270.392 215.416H314.285ZM326.338 215.416H400.974V253.614C379.592 254.131 359.125 257.402 340.052 263.362C337.806 264.063 335.589 264.805 333.402 265.578C329.198 249.926 326.789 232.972 326.338 215.416ZM400.974 265.679V345.828C382.212 343.445 364.581 329.966 350.795 307.268C345.288 298.202 340.645 288.078 336.928 277.171C356.211 270.315 378.209 266.286 400.974 265.679ZM413.025 345.828V265.679C435.812 266.285 457.801 270.31 477.075 277.164C473.357 288.073 468.713 298.199 463.206 307.268C449.42 329.966 431.787 343.445 413.025 345.828ZM474.377 263.496C455.185 257.451 434.573 254.135 413.025 253.615V215.418H487.661C487.21 232.974 484.801 249.926 480.599 265.578C478.55 264.853 476.477 264.158 474.377 263.496ZM499.714 215.416H543.606C542.471 241.472 534.021 265.659 520.262 285.969C511.958 279.92 502.378 274.535 491.868 269.994C496.566 252.959 499.247 234.501 499.714 215.416ZM499.714 203.358C499.247 184.273 496.565 165.816 491.87 148.78C502.38 144.24 511.962 138.854 520.265 132.807C534.023 153.116 542.473 177.302 543.607 203.358H499.714ZM513.07 123.132C505.763 128.447 497.418 133.148 488.282 137.162C484.313 125.627 479.364 114.892 473.503 105.243C467.732 95.7416 461.278 87.6209 454.233 80.9791C477.449 89.5557 497.718 104.265 513.07 123.132ZM359.765 80.9778C352.72 87.6196 346.266 95.7403 340.495 105.241C334.634 114.891 329.685 125.625 325.716 137.161C316.581 133.148 308.235 128.446 300.928 123.131C316.281 104.265 336.551 89.5557 359.765 80.9778ZM300.929 295.642C308.237 290.327 316.581 285.625 325.717 281.612C329.686 293.147 334.636 303.882 340.496 313.531C346.267 323.032 352.721 331.153 359.766 337.795C336.551 329.219 316.281 314.509 300.929 295.642ZM454.234 337.796C461.279 331.154 467.733 323.034 473.504 313.533C479.366 303.881 484.317 293.144 488.286 281.604C497.418 285.618 505.761 290.323 513.071 295.642C497.718 314.509 477.449 329.219 454.234 337.796Z",
    fill: "url(#paint0_linear_1034_134)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M562.22 365.189H251.78C245.359 365.189 240.153 370.397 240.153 376.822C240.153 383.247 245.359 388.455 251.78 388.455H339.412C345.833 388.455 351.038 393.664 351.038 400.088C351.038 406.513 345.832 411.722 339.412 411.722H312.096C305.675 411.722 300.471 416.931 300.471 423.355C300.471 429.78 305.675 434.988 312.096 434.988H330.782H353.832H494.228C500.649 434.988 505.854 429.78 505.854 423.355C505.854 416.93 500.648 411.722 494.228 411.722H422.474C416.053 411.722 410.847 406.513 410.847 400.088C410.847 393.663 416.053 388.455 422.474 388.455H562.221C568.643 388.455 573.847 383.246 573.847 376.822C573.846 370.397 568.641 365.189 562.22 365.189Z",
    fill: "#C5CAE9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M496.547 233.166H313.099V357.758H496.547V233.166Z",
    fill: "url(#paint1_linear_1034_134)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M407 148.792L296.909 209.388H517.091L407 148.792Z",
    fill: "url(#paint2_linear_1034_134)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M533.421 209.388H280.58V225.239H533.421V209.388Z",
    fill: "url(#paint3_linear_1034_134)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M533.421 220.709H280.58V225.239H533.421V220.709Z",
    fill: "url(#paint4_linear_1034_134)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M533.421 357.758H280.58V373.609H533.421V357.758Z",
    fill: "url(#paint5_linear_1034_134)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M522.107 225.239H291.894V233.166H522.107V225.239Z",
    fill: "url(#paint6_linear_1034_134)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M336.789 233.166H298.119V243.362H336.789V233.166Z",
    fill: "url(#paint7_linear_1034_134)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M336.789 347.562H298.119V357.758H336.789V347.562Z",
    fill: "url(#paint8_linear_1034_134)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M330.967 243.361H303.94V347.562H330.967V243.361Z",
    fill: "url(#paint9_linear_1034_134)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M330.966 243.361H322.801V347.562H330.966V243.361Z",
    fill: "url(#paint10_linear_1034_134)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M396.486 233.166H357.816V243.362H396.486V233.166Z",
    fill: "url(#paint11_linear_1034_134)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M396.486 347.562H357.816V357.758H396.486V347.562Z",
    fill: "url(#paint12_linear_1034_134)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M390.663 243.361H363.637V347.562H390.663V243.361Z",
    fill: "url(#paint13_linear_1034_134)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M390.664 243.361H382.499V347.562H390.664V243.361Z",
    fill: "url(#paint14_linear_1034_134)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M456.183 233.166H417.514V243.362H456.183V233.166Z",
    fill: "url(#paint15_linear_1034_134)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M456.183 347.562H417.514V357.758H456.183V347.562Z",
    fill: "url(#paint16_linear_1034_134)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M450.362 243.361H423.335V347.562H450.362V243.361Z",
    fill: "url(#paint17_linear_1034_134)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M450.362 243.361H442.197V347.562H450.362V243.361Z",
    fill: "url(#paint18_linear_1034_134)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M515.881 233.166H477.211V243.362H515.881V233.166Z",
    fill: "url(#paint19_linear_1034_134)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M515.881 347.562H477.211V357.758H515.881V347.562Z",
    fill: "url(#paint20_linear_1034_134)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M510.06 243.361H483.033V347.562H510.06V243.361Z",
    fill: "url(#paint21_linear_1034_134)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M510.06 243.361H501.895V347.562H510.06V243.361Z",
    fill: "url(#paint22_linear_1034_134)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M344.348 193.759V201.125H469.652V193.759L407 159.276L344.348 193.759Z",
    fill: "url(#paint23_linear_1034_134)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M469.65 193.759H344.348V201.125H469.65V193.759Z",
    fill: "url(#paint24_linear_1034_134)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M669.905 455.21L718.809 426.957C725.248 423.237 729.215 416.362 729.215 408.923V352.418C729.215 344.979 725.248 338.104 718.809 334.384L669.905 306.131C663.466 302.411 655.532 302.411 649.094 306.131L600.189 334.384C593.751 338.104 589.784 344.979 589.784 352.418V408.923C589.784 416.362 593.751 423.237 600.189 426.957L649.094 455.21C655.532 458.93 663.466 458.93 669.905 455.21Z",
    fill: "#7D8FD8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M652.946 311.248L602.692 340.281C598.636 342.623 596.139 346.952 596.139 351.638V409.703C596.139 414.388 598.636 418.718 602.692 421.06L652.946 450.093C657.002 452.435 661.998 452.435 666.052 450.093L716.307 421.06C720.362 418.718 722.86 414.388 722.86 409.703V351.638C722.86 346.952 720.362 342.623 716.307 340.281L666.052 311.248C661.997 308.905 657.002 308.905 652.946 311.248Z",
    fill: "url(#paint25_linear_1034_134)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M696.168 393.325C692.738 391.245 683.065 389.743 671.659 389.743C660.254 389.743 650.581 391.243 647.15 393.325H645.813V400.475C645.813 403.373 657.385 405.723 671.659 405.723C685.933 405.723 697.505 403.373 697.505 400.475V393.325H696.168Z",
    fill: "url(#paint26_linear_1034_134)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M649.608 403.214C651.03 403.685 652.81 404.106 654.869 404.464V391.004C652.808 391.362 651.031 391.786 649.608 392.258V403.214Z",
    fill: "#FFA000"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.046 404.534C690.085 404.194 691.859 403.791 693.307 403.341V392.127C691.86 391.677 690.085 391.275 688.046 390.935V404.534Z",
    fill: "#FFA000"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M657.692 404.89C658.627 405.012 659.602 405.123 660.615 405.22V390.246C659.602 390.343 658.627 390.454 657.692 390.576V404.89Z",
    fill: "#FFA000"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M683.994 405.088C685.012 404.975 685.986 404.848 686.916 404.71V390.756C685.988 390.618 685.01 390.493 683.994 390.38V405.088Z",
    fill: "#FFA000"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M662.077 405.35C662.652 405.396 663.236 405.439 663.83 405.478V390.245H662.077V405.35Z",
    fill: "#FFA000"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M671.659 398.573C685.934 398.573 697.505 396.224 697.505 393.326C697.505 390.427 685.934 388.078 671.659 388.078C657.385 388.078 645.813 390.427 645.813 393.326C645.813 396.224 657.385 398.573 671.659 398.573Z",
    fill: "url(#paint27_linear_1034_134)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M696.168 382.013C692.738 379.932 683.065 378.431 671.659 378.431C660.254 378.431 650.581 379.931 647.15 382.013H645.813V389.163C645.813 392.061 657.385 394.411 671.659 394.411C685.933 394.411 697.505 392.061 697.505 389.163V382.013H696.168Z",
    fill: "url(#paint28_linear_1034_134)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M649.608 391.9C651.03 392.371 652.81 392.792 654.869 393.15V379.69C652.808 380.048 651.031 380.472 649.608 380.944V391.9Z",
    fill: "#FFA000"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.046 393.221C690.085 392.881 691.859 392.478 693.307 392.029V380.814C691.86 380.365 690.085 379.962 688.046 379.622V393.221Z",
    fill: "#FFA000"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M657.692 393.577C658.627 393.699 659.602 393.81 660.615 393.907V378.933C659.602 379.03 658.627 379.141 657.692 379.263V393.577Z",
    fill: "#FFA000"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M683.994 393.775C685.012 393.663 685.986 393.536 686.916 393.398V379.444C685.988 379.306 685.01 379.181 683.994 379.068V393.775Z",
    fill: "#FFA000"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M662.077 394.037C662.652 394.083 663.236 394.127 663.83 394.165V378.932H662.077V394.037Z",
    fill: "#FFA000"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M671.659 387.26C685.934 387.26 697.505 384.911 697.505 382.013C697.505 379.115 685.934 376.765 671.659 376.765C657.385 376.765 645.813 379.115 645.813 382.013C645.813 384.911 657.385 387.26 671.659 387.26Z",
    fill: "url(#paint29_linear_1034_134)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M696.168 370.7C692.738 368.619 683.065 367.118 671.659 367.118C660.254 367.118 650.581 368.618 647.15 370.7H645.813V377.85C645.813 380.748 657.385 383.098 671.659 383.098C685.933 383.098 697.505 380.748 697.505 377.85V370.7H696.168Z",
    fill: "url(#paint30_linear_1034_134)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M649.608 380.587C651.03 381.058 652.81 381.479 654.869 381.837V368.377C652.808 368.736 651.031 369.159 649.608 369.631V380.587Z",
    fill: "#FFA000"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.046 381.908C690.085 381.568 691.859 381.165 693.307 380.716V369.501C691.86 369.052 690.085 368.649 688.046 368.309V381.908Z",
    fill: "#FFA000"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M657.692 382.265C658.627 382.387 659.602 382.497 660.615 382.595V367.62C659.602 367.718 658.627 367.828 657.692 367.951V382.265Z",
    fill: "#FFA000"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M683.994 382.462C685.012 382.35 685.986 382.223 686.916 382.085V368.131C685.988 367.993 685.01 367.868 683.994 367.755V382.462Z",
    fill: "#FFA000"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M662.077 382.723C662.652 382.769 663.236 382.812 663.83 382.851V367.618H662.077V382.723Z",
    fill: "#FFA000"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M671.659 375.948C685.934 375.948 697.505 373.598 697.505 370.7C697.505 367.802 685.934 365.452 671.659 365.452C657.385 365.452 645.813 367.802 645.813 370.7C645.813 373.598 657.385 375.948 671.659 375.948Z",
    fill: "url(#paint31_linear_1034_134)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M696.168 359.387C692.738 357.307 683.065 355.805 671.659 355.805C660.254 355.805 650.581 357.305 647.15 359.387H645.813V366.537C645.813 369.435 657.385 371.785 671.659 371.785C685.933 371.785 697.505 369.435 697.505 366.537V359.387H696.168Z",
    fill: "url(#paint32_linear_1034_134)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M649.608 369.275C651.03 369.746 652.81 370.167 654.869 370.524V357.065C652.808 357.424 651.031 357.846 649.608 358.318V369.275Z",
    fill: "#FFA000"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.046 370.595C690.085 370.255 691.859 369.853 693.307 369.403V358.189C691.86 357.739 690.085 357.337 688.046 356.997V370.595Z",
    fill: "#FFA000"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M657.692 370.952C658.627 371.074 659.602 371.185 660.615 371.282V356.308C659.602 356.405 658.627 356.516 657.692 356.638V370.952Z",
    fill: "#FFA000"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M683.994 371.15C685.012 371.037 685.986 370.91 686.916 370.772V356.818C685.988 356.68 685.01 356.555 683.994 356.442V371.15Z",
    fill: "#FFA000"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M662.077 371.41C662.652 371.456 663.236 371.5 663.83 371.538V356.305H662.077V371.41Z",
    fill: "#FFA000"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M671.659 364.635C685.934 364.635 697.505 362.286 697.505 359.388C697.505 356.489 685.934 354.14 671.659 354.14C657.385 354.14 645.813 356.489 645.813 359.388C645.813 362.286 657.385 364.635 671.659 364.635Z",
    fill: "url(#paint33_linear_1034_134)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M696.168 348.075C692.738 345.994 683.065 344.493 671.659 344.493C660.254 344.493 650.581 345.993 647.15 348.075H645.813V355.225C645.813 358.123 657.385 360.472 671.659 360.472C685.933 360.472 697.505 358.123 697.505 355.225V348.075H696.168Z",
    fill: "url(#paint34_linear_1034_134)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M649.608 357.962C651.03 358.433 652.81 358.854 654.869 359.212V345.753C652.808 346.112 651.031 346.534 649.608 347.006V357.962Z",
    fill: "#FFA000"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.046 359.282C690.085 358.942 691.859 358.539 693.307 358.089V346.875C691.86 346.425 690.085 346.023 688.046 345.683V359.282Z",
    fill: "#FFA000"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M657.692 359.639C658.627 359.761 659.602 359.872 660.615 359.969V344.995C659.602 345.092 658.627 345.203 657.692 345.325V359.639Z",
    fill: "#FFA000"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M683.994 359.837C685.012 359.725 685.986 359.598 686.916 359.46V345.506C685.988 345.368 685.01 345.243 683.994 345.13V359.837Z",
    fill: "#FFA000"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M662.077 360.098C662.652 360.144 663.236 360.187 663.83 360.226V344.992H662.077V360.098Z",
    fill: "#FFA000"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M671.659 353.323C685.934 353.323 697.505 350.973 697.505 348.075C697.505 345.177 685.934 342.827 671.659 342.827C657.385 342.827 645.813 345.177 645.813 348.075C645.813 350.973 657.385 353.323 671.659 353.323Z",
    fill: "url(#paint35_linear_1034_134)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M645.813 418.515C663.063 418.515 677.048 404.522 677.048 387.261C677.048 369.999 663.063 356.006 645.813 356.006C628.562 356.006 614.578 369.999 614.578 387.261C614.578 404.522 628.562 418.515 645.813 418.515Z",
    fill: "#FDD835"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M645.813 414.29C660.732 414.29 672.826 402.188 672.826 387.26C672.826 372.332 660.732 360.231 645.813 360.231C630.894 360.231 618.8 372.332 618.8 387.26C618.8 402.188 630.894 414.29 645.813 414.29Z",
    fill: "url(#paint36_linear_1034_134)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M644.157 410.975C658.161 410.975 669.514 399.615 669.514 385.602C669.514 371.863 658.599 360.675 644.971 360.245C645.251 360.236 645.532 360.23 645.814 360.23C660.733 360.23 672.827 372.331 672.827 387.259C672.827 402.188 660.733 414.289 645.814 414.289C630.895 414.289 618.801 402.188 618.801 387.259C618.801 386.977 618.808 386.696 618.816 386.416C619.245 400.052 630.424 410.975 644.157 410.975Z",
    fill: "url(#paint37_linear_1034_134)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M644.244 403.161V400.517C642.022 400.256 640.432 399.476 639.473 398.175C638.515 396.874 638.036 394.98 638.036 392.496V391.52H644.208V392.265C644.208 394.087 644.781 394.998 645.929 394.998C646.426 394.998 646.789 394.844 647.02 394.537C647.25 394.229 647.366 393.869 647.366 393.454C647.366 392.72 646.994 391.975 646.249 391.217L641.159 386.089C639.291 384.221 638.357 382.191 638.357 380.003C638.357 378.821 638.626 377.777 639.164 376.871C639.702 375.967 640.417 375.227 641.31 374.653C642.202 374.08 643.181 373.698 644.244 373.508V371.362H647.312V373.456C649.334 373.717 650.871 374.55 651.923 375.958C652.975 377.366 653.502 379.23 653.502 381.548H647.17V380.394C647.17 379.886 647.035 379.495 646.762 379.223C646.489 378.952 646.129 378.815 645.68 378.815C645.183 378.815 644.811 378.939 644.563 379.187C644.315 379.435 644.191 379.767 644.191 380.181C644.191 380.773 644.776 381.648 645.946 382.808L650.912 387.705C651.645 388.427 652.274 389.303 652.801 390.332C653.326 391.361 653.59 392.526 653.59 393.828C653.59 395.78 652.993 397.339 651.799 398.503C650.604 399.668 649.109 400.352 647.311 400.553V403.162L644.244 403.161Z",
    fill: "url(#paint38_linear_1034_134)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M645.813 387.261C653.795 379.273 657.699 368.751 657.528 358.281C653.91 356.815 649.957 356.006 645.813 356.006C628.562 356.006 614.578 369.999 614.578 387.261C614.578 391.407 615.387 395.363 616.851 398.983C627.314 399.154 637.83 395.248 645.813 387.261Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M164.906 455.21L213.81 426.957C220.249 423.237 224.216 416.362 224.216 408.923V352.418C224.216 344.979 220.249 338.104 213.81 334.384L164.906 306.131C158.467 302.411 150.533 302.411 144.095 306.131L95.1901 334.384C88.7516 338.104 84.7847 344.979 84.7847 352.418V408.923C84.7847 416.362 88.7516 423.237 95.1901 426.957L144.095 455.21C150.533 458.93 158.467 458.93 164.906 455.21Z",
    fill: "#7D8FD8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M147.947 311.248L97.6922 340.281C93.6369 342.623 91.1392 346.952 91.1392 351.638V409.703C91.1392 414.388 93.6369 418.718 97.6922 421.06L147.947 450.093C152.002 452.435 156.999 452.435 161.053 450.093L211.307 421.06C215.362 418.718 217.86 414.388 217.86 409.703V351.638C217.86 346.952 215.362 342.623 211.307 340.281L161.053 311.248C156.997 308.905 152.002 308.905 147.947 311.248Z",
    fill: "url(#paint39_linear_1034_134)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M172.598 406.978H108.565C107.115 406.978 105.94 405.802 105.94 404.352V366.276C105.94 364.826 107.115 363.65 108.565 363.65H172.598C174.047 363.65 175.222 364.826 175.222 366.276V404.352C175.222 405.802 174.047 406.978 172.598 406.978Z",
    fill: "url(#paint40_linear_1034_134)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M108.565 363.65C107.115 363.65 105.94 364.826 105.94 366.276V404.352C105.94 405.802 107.115 406.978 108.565 406.978H112.199L155.501 363.65H108.565Z",
    fill: "url(#paint41_linear_1034_134)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M166.665 381.791C166.569 381.791 166.472 381.754 166.399 381.68C166.252 381.533 166.252 381.295 166.399 381.148C167.216 380.331 167.665 379.243 167.665 378.085C167.665 376.926 167.216 375.838 166.399 375.021C166.252 374.874 166.252 374.636 166.399 374.489C166.546 374.342 166.784 374.342 166.93 374.489C167.889 375.448 168.418 376.725 168.418 378.085C168.418 379.444 167.89 380.721 166.93 381.68C166.858 381.755 166.762 381.791 166.665 381.791Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M165.557 380.681C165.461 380.681 165.364 380.643 165.29 380.57C165.143 380.423 165.143 380.184 165.29 380.038C165.811 379.517 166.098 378.823 166.098 378.084C166.098 377.346 165.812 376.652 165.29 376.131C165.143 375.984 165.143 375.746 165.29 375.599C165.437 375.452 165.675 375.452 165.822 375.599C166.486 376.263 166.851 377.145 166.851 378.084C166.851 379.024 166.486 379.907 165.822 380.57C165.749 380.645 165.653 380.681 165.557 380.681Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M164.447 379.572C164.352 379.572 164.254 379.535 164.181 379.461C164.034 379.314 164.034 379.076 164.181 378.929C164.406 378.704 164.53 378.405 164.53 378.086C164.53 377.767 164.406 377.468 164.181 377.242C164.034 377.095 164.034 376.857 164.181 376.71C164.328 376.563 164.566 376.563 164.713 376.71C165.08 377.078 165.282 377.566 165.282 378.087C165.282 378.608 165.08 379.096 164.713 379.464C164.639 379.535 164.543 379.572 164.447 379.572Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M163.338 378.587C163.615 378.587 163.84 378.362 163.84 378.085C163.84 377.807 163.615 377.583 163.338 377.583C163.061 377.583 162.836 377.807 162.836 378.085C162.836 378.362 163.061 378.587 163.338 378.587Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M165.598 381.603C165.502 381.603 165.405 381.565 165.331 381.492C165.184 381.345 165.184 381.107 165.331 380.96C166.148 380.143 166.598 379.055 166.598 377.896C166.598 376.738 166.148 375.65 165.331 374.833C165.184 374.686 165.184 374.448 165.331 374.301C165.478 374.154 165.716 374.154 165.863 374.301C166.822 375.26 167.351 376.537 167.351 377.896C167.351 379.256 166.823 380.533 165.863 381.492C165.791 381.567 165.694 381.603 165.598 381.603Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M164.488 380.493C164.393 380.493 164.295 380.455 164.222 380.382C164.075 380.235 164.075 379.995 164.222 379.85C164.742 379.329 165.03 378.635 165.03 377.896C165.03 377.157 164.744 376.463 164.222 375.943C164.075 375.796 164.075 375.558 164.222 375.411C164.369 375.264 164.607 375.264 164.754 375.411C165.417 376.075 165.782 376.957 165.782 377.896C165.782 378.835 165.417 379.719 164.754 380.382C164.681 380.456 164.584 380.493 164.488 380.493Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M163.379 379.382C163.283 379.382 163.186 379.345 163.113 379.272C162.966 379.125 162.966 378.887 163.113 378.74C163.338 378.514 163.461 378.215 163.461 377.896C163.461 377.577 163.338 377.278 163.113 377.053C162.966 376.906 162.966 376.668 163.113 376.521C163.26 376.374 163.497 376.374 163.644 376.521C164.012 376.888 164.213 377.377 164.213 377.897C164.213 378.418 164.012 378.907 163.644 379.274C163.572 379.346 163.475 379.382 163.379 379.382Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M162.269 378.399C162.546 378.399 162.771 378.174 162.771 377.896C162.771 377.619 162.546 377.394 162.269 377.394C161.992 377.394 161.768 377.619 161.768 377.896C161.768 378.174 161.992 378.399 162.269 378.399Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M122.371 381.6H113.771C113.203 381.6 112.744 381.141 112.744 380.573V375.221C112.744 374.653 113.203 374.194 113.771 374.194H122.371C122.939 374.194 123.398 374.653 123.398 375.221V380.573C123.398 381.141 122.939 381.6 122.371 381.6Z",
    fill: "url(#paint42_linear_1034_134)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.744 385.313H112.744V389.193H115.744V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.436 385.313H117.435V389.193H120.436V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.128 385.313H122.127V389.193H125.128V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.819 385.313H126.818V389.193H129.819V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.511 385.313H131.51V389.193H134.511V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.202 385.313H136.202V389.193H139.202V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.894 385.313H140.894V389.193H143.894V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.586 385.313H145.585V389.193H148.586V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.277 385.313H150.276V389.193H153.277V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.969 385.313H154.968V389.193H157.969V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66 385.313H159.66V389.193H162.66V385.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.352 385.313H164.351V389.193H167.352V385.313Z",
    fill: "white"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M166.381 369.816H156.295C155.759 369.816 155.324 369.381 155.324 368.844C155.324 368.307 155.759 367.872 156.295 367.872H166.381C166.918 367.872 167.352 368.307 167.352 368.844C167.351 369.381 166.916 369.816 166.381 369.816Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M148.948 393.991H142.042C141.505 393.991 141.07 393.556 141.07 393.019C141.07 392.482 141.505 392.047 142.042 392.047H148.948C149.485 392.047 149.919 392.482 149.919 393.019C149.919 393.556 149.485 393.991 148.948 393.991Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M120.621 397.474H113.714C113.177 397.474 112.743 397.039 112.743 396.502C112.743 395.965 113.177 395.531 113.714 395.531H120.621C121.157 395.531 121.592 395.965 121.592 396.502C121.592 397.039 121.157 397.474 120.621 397.474Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M129.09 401.645H113.715C113.178 401.645 112.744 401.211 112.744 400.674C112.744 400.137 113.178 399.702 113.715 399.702H129.09C129.626 399.702 130.061 400.137 130.061 400.674C130.061 401.211 129.626 401.645 129.09 401.645Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M200.435 397.692H136.402C134.953 397.692 133.777 396.516 133.777 395.066V356.99C133.777 355.54 134.953 354.364 136.402 354.364H200.435C201.884 354.364 203.06 355.54 203.06 356.99V395.066C203.06 396.516 201.884 397.692 200.435 397.692Z",
    fill: "url(#paint43_linear_1034_134)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M136.402 354.364C134.953 354.364 133.777 355.54 133.777 356.99V395.066C133.777 396.516 134.953 397.692 136.402 397.692H140.037L183.338 354.364H136.402Z",
    fill: "url(#paint44_linear_1034_134)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M194.503 372.506C194.407 372.506 194.31 372.469 194.237 372.396C194.09 372.249 194.09 372.011 194.237 371.864C195.053 371.046 195.503 369.959 195.503 368.8C195.503 367.641 195.053 366.554 194.237 365.736C194.09 365.589 194.09 365.351 194.237 365.204C194.384 365.057 194.621 365.057 194.768 365.204C195.727 366.164 196.256 367.441 196.256 368.8C196.256 370.159 195.728 371.436 194.768 372.396C194.695 372.469 194.599 372.506 194.503 372.506Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M193.394 371.396C193.298 371.396 193.201 371.359 193.127 371.285C192.98 371.138 192.98 370.899 193.127 370.753C193.648 370.233 193.935 369.539 193.935 368.8C193.935 368.061 193.649 367.367 193.127 366.846C192.98 366.699 192.98 366.461 193.127 366.314C193.274 366.167 193.512 366.167 193.659 366.314C194.323 366.978 194.687 367.861 194.687 368.8C194.687 369.739 194.323 370.623 193.659 371.285C193.585 371.359 193.49 371.396 193.394 371.396Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M192.284 370.286C192.188 370.286 192.091 370.249 192.018 370.175C191.871 370.028 191.871 369.79 192.018 369.643C192.243 369.418 192.367 369.119 192.367 368.8C192.367 368.481 192.243 368.182 192.018 367.956C191.871 367.809 191.871 367.571 192.018 367.424C192.165 367.277 192.403 367.277 192.55 367.424C192.917 367.792 193.119 368.28 193.119 368.801C193.119 369.322 192.917 369.81 192.55 370.178C192.477 370.249 192.38 370.286 192.284 370.286Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M191.175 369.302C191.452 369.302 191.676 369.078 191.676 368.8C191.676 368.523 191.452 368.298 191.175 368.298C190.898 368.298 190.673 368.523 190.673 368.8C190.673 369.078 190.898 369.302 191.175 369.302Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M193.435 372.319C193.339 372.319 193.242 372.281 193.169 372.208C193.022 372.061 193.022 371.823 193.169 371.676C193.986 370.858 194.435 369.77 194.435 368.612C194.435 367.455 193.986 366.366 193.169 365.549C193.022 365.401 193.022 365.164 193.169 365.017C193.316 364.869 193.554 364.869 193.7 365.017C194.659 365.976 195.188 367.253 195.188 368.612C195.188 369.971 194.66 371.248 193.7 372.208C193.628 372.281 193.532 372.319 193.435 372.319Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M192.325 371.208C192.23 371.208 192.132 371.171 192.059 371.097C191.912 370.95 191.912 370.711 192.059 370.565C192.579 370.045 192.867 369.351 192.867 368.612C192.867 367.873 192.581 367.179 192.059 366.658C191.912 366.511 191.912 366.273 192.059 366.126C192.206 365.979 192.444 365.979 192.591 366.126C193.254 366.79 193.619 367.673 193.619 368.612C193.619 369.551 193.254 370.435 192.591 371.097C192.518 371.171 192.423 371.208 192.325 371.208Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M191.216 370.098C191.121 370.098 191.023 370.061 190.95 369.987C190.803 369.84 190.803 369.602 190.95 369.455C191.175 369.23 191.299 368.931 191.299 368.612C191.299 368.293 191.175 367.994 190.95 367.768C190.803 367.621 190.803 367.383 190.95 367.236C191.097 367.089 191.335 367.089 191.482 367.236C191.849 367.604 192.051 368.092 192.051 368.613C192.051 369.134 191.849 369.622 191.482 369.99C191.409 370.061 191.314 370.098 191.216 370.098Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M190.108 369.114C190.385 369.114 190.61 368.89 190.61 368.612C190.61 368.335 190.385 368.11 190.108 368.11C189.831 368.11 189.606 368.335 189.606 368.612C189.606 368.89 189.831 369.114 190.108 369.114Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M150.208 372.314H141.608C141.04 372.314 140.581 371.855 140.581 371.287V365.936C140.581 365.367 141.04 364.908 141.608 364.908H150.208C150.776 364.908 151.235 365.367 151.235 365.936V371.287C151.235 371.855 150.776 372.314 150.208 372.314Z",
    fill: "url(#paint45_linear_1034_134)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.581 376.029H140.581V379.908H143.581V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.273 376.029H145.272V379.908H148.273V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.965 376.029H149.964V379.908H152.965V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.656 376.029H154.655V379.908H157.656V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.347 376.029H159.347V379.908H162.347V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.039 376.029H164.039V379.908H167.039V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.731 376.029H168.73V379.908H171.731V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.423 376.029H173.422V379.908H176.423V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.115 376.029H178.114V379.908H181.115V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.806 376.029H182.805V379.908H185.806V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.498 376.029H187.497V379.908H190.498V376.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.189 376.029H192.188V379.908H195.189V376.029Z",
    fill: "white"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M194.218 360.53H184.132C183.596 360.53 183.161 360.095 183.161 359.558C183.161 359.021 183.596 358.586 184.132 358.586H194.218C194.754 358.586 195.189 359.021 195.189 359.558C195.188 360.095 194.753 360.53 194.218 360.53Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M176.786 384.705H169.879C169.343 384.705 168.908 384.27 168.908 383.733C168.908 383.196 169.343 382.761 169.879 382.761H176.786C177.323 382.761 177.757 383.196 177.757 383.733C177.756 384.27 177.321 384.705 176.786 384.705Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M148.458 388.189H141.552C141.015 388.189 140.581 387.754 140.581 387.217C140.581 386.68 141.015 386.245 141.552 386.245H148.458C148.995 386.245 149.43 386.68 149.43 387.217C149.428 387.754 148.994 388.189 148.458 388.189Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M156.927 392.36H141.552C141.015 392.36 140.581 391.925 140.581 391.388C140.581 390.851 141.015 390.416 141.552 390.416H156.927C157.463 390.416 157.898 390.851 157.898 391.388C157.898 391.925 157.463 392.36 156.927 392.36Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3165 174.798L19.4118 203.051C12.9733 206.771 9.00635 213.646 9.00635 221.085V277.59C9.00635 285.029 12.9733 291.904 19.4118 295.624L68.3165 323.877C74.755 327.597 82.6889 327.597 89.1274 323.877L138.032 295.624C144.471 291.904 148.438 285.029 148.438 277.59V221.085C148.438 213.646 144.471 206.771 138.032 203.051L89.1274 174.798C82.6889 171.079 74.755 171.079 68.3165 174.798Z",
    fill: "#7D8FD8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M72.169 179.915L21.9134 208.948C17.8581 211.29 15.3604 215.619 15.3604 220.305V278.37C15.3604 283.055 17.8581 287.385 21.9134 289.727L72.1678 318.76C76.2231 321.102 81.2198 321.102 85.2739 318.76L135.528 289.727C139.584 287.385 142.081 283.055 142.081 278.37V220.305C142.081 215.619 139.584 211.29 135.528 208.948L85.2739 179.915C81.2198 177.572 76.2231 177.572 72.169 179.915Z",
    fill: "url(#paint46_linear_1034_134)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4599 254.055C82.0517 252.892 81.2324 251.166 81.2324 249.338C81.2324 247.511 82.0517 245.785 83.4599 244.621C88.1378 240.754 98.5558 230.481 98.5558 215.676H78.7222H58.8887C58.8887 230.481 69.3054 240.754 73.9845 244.621C75.3928 245.785 76.2121 247.511 76.2121 249.338C76.2121 251.166 75.3928 252.892 73.9845 254.055C69.3066 257.923 58.8887 268.196 58.8887 283.001H78.7222H98.5558C98.5558 268.195 88.1391 257.923 83.4599 254.055Z",
    fill: "url(#paint47_linear_1034_134)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8887 283.001H78.7222H98.5558C98.5558 274.498 95.1192 267.494 91.3079 262.336L62.5506 268.125C60.4102 272.352 58.8887 277.344 58.8887 283.001Z",
    fill: "url(#paint48_linear_1034_134)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5558 215.674H78.7222H58.8887C58.8887 219.206 59.4863 222.477 60.4526 225.467L91.8072 235.651C95.4131 230.565 98.5558 223.805 98.5558 215.674Z",
    fill: "url(#paint49_linear_1034_134)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2322 249.338C81.2322 247.51 82.0515 245.785 83.4598 244.621C85.569 242.878 88.8437 239.828 91.8058 235.652L60.4512 225.468C63.5353 235.014 70.4209 241.677 73.9832 244.621C75.3914 245.785 76.2107 247.51 76.2107 249.338H81.2322Z",
    fill: "url(#paint50_linear_1034_134)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M100.511 213.665H56.9321V217.684H100.511V213.665Z",
    fill: "url(#paint51_linear_1034_134)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M100.511 280.991H56.9321V285.01H100.511V280.991Z",
    fill: "url(#paint52_linear_1034_134)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M724.872 174.798L675.967 203.051C669.529 206.771 665.562 213.646 665.562 221.085V277.59C665.562 285.029 669.529 291.904 675.967 295.624L724.872 323.877C731.31 327.597 739.244 327.597 745.683 323.877L794.587 295.624C801.026 291.904 804.993 285.029 804.993 277.59V221.085C804.993 213.646 801.026 206.771 794.587 203.051L745.683 174.798C739.244 171.079 731.311 171.079 724.872 174.798Z",
    fill: "#7D8FD8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M728.724 179.915L678.47 208.948C674.415 211.29 671.917 215.619 671.917 220.305V278.37C671.917 283.055 674.415 287.385 678.47 289.727L728.724 318.76C732.78 321.102 737.776 321.102 741.831 318.76L792.085 289.727C796.14 287.385 798.638 283.055 798.638 278.37V220.305C798.638 215.619 796.14 211.29 792.085 208.948L741.831 179.915C737.776 177.572 732.78 177.572 728.724 179.915Z",
    fill: "url(#paint53_linear_1034_134)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M721.937 234.333V224.804C721.937 217.432 727.91 211.456 735.277 211.456C742.645 211.456 748.617 217.432 748.617 224.804V234.333",
    stroke: "url(#paint54_linear_1034_134)",
    strokeWidth: 3.3383,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M710.375 233.827V281.508C710.375 284.663 712.929 287.22 716.082 287.22H754.472C757.624 287.22 760.179 284.663 760.179 281.508V233.827H710.375ZM737.365 261.176V270.874H733.189V261.176C731.076 260.341 729.577 258.29 729.577 255.879C729.577 252.728 732.129 250.176 735.277 250.176C738.426 250.176 740.977 252.73 740.977 255.879C740.978 258.29 739.478 260.341 737.365 261.176Z",
    fill: "url(#paint55_linear_1034_134)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M753.513 233.827V281.508C753.513 284.663 750.958 287.22 747.805 287.22H754.472C757.624 287.22 760.179 284.663 760.179 281.508V233.827H753.513Z",
    fill: "url(#paint56_linear_1034_134)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M649.094 44.0497L600.189 72.3027C593.751 76.0229 589.784 82.8977 589.784 90.3369V146.842C589.784 154.281 593.751 161.156 600.189 164.876L649.094 193.129C655.532 196.849 663.466 196.849 669.905 193.129L718.809 164.876C725.248 161.156 729.215 154.281 729.215 146.842V90.3369C729.215 82.8977 725.248 76.0229 718.809 72.3027L669.905 44.0497C663.466 40.3295 655.532 40.3295 649.094 44.0497Z",
    fill: "#7D8FD8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M652.946 49.1651L602.692 78.198C598.636 80.5403 596.139 84.8698 596.139 89.5555V147.62C596.139 152.306 598.636 156.635 602.692 158.978L652.946 188.01C657.002 190.353 661.998 190.353 666.052 188.01L716.307 158.978C720.362 156.635 722.86 152.306 722.86 147.62V89.5555C722.86 84.8698 720.362 80.5403 716.307 78.198L666.052 49.1651C661.997 46.8229 657.002 46.8229 652.946 49.1651Z",
    fill: "url(#paint57_linear_1034_134)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M669.493 165.353H633.982C631.825 165.353 630.076 163.604 630.076 161.445V95.11C630.076 92.9521 631.824 91.2017 633.982 91.2017H669.493C671.649 91.2017 673.398 92.9509 673.398 95.11V161.445C673.398 163.603 671.649 165.353 669.493 165.353Z",
    fill: "url(#paint58_linear_1034_134)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M671.153 98.52H632.321V158.035H671.153V98.52Z",
    fill: "url(#paint59_linear_1034_134)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M671.153 155.129H632.321V158.035H671.153V155.129Z",
    fill: "url(#paint60_linear_1034_134)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.398 95.11C673.398 92.9521 671.65 91.2017 669.493 91.2017H633.982C631.825 91.2017 630.076 92.9509 630.076 95.11V142.486L673.398 99.1367V95.11Z",
    fill: "white"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M686.894 71.8245L685.879 73.2734L684.867 71.8245L683.852 73.2734L682.838 71.8245L681.825 73.2734L680.811 71.8245L679.799 73.2734L678.786 71.8245L677.772 73.2734L676.758 71.8245L675.745 73.2734L674.731 71.8245L673.718 73.2734L672.704 71.8245L671.691 73.2734L670.678 71.8245L669.665 73.2734L668.651 71.8245L667.639 73.2734L666.626 71.8245L665.612 73.2734L664.6 71.8245L663.587 73.2734L662.574 71.8245L661.562 73.2734L660.549 71.8245L659.536 73.2734L658.524 71.8245L657.51 73.2734L656.497 71.8245V137.074H688.923V71.8245L687.908 73.2734L686.894 71.8245Z",
    fill: "url(#paint61_linear_1034_134)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M676.184 76.0664H659.826V77.9489H676.184V76.0664Z",
    fill: "#7986CB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M681.395 87.5103H659.826V89.3928H681.395V87.5103Z",
    fill: "#7986CB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M677.775 92.2908H659.826V94.1733H677.775V92.2908Z",
    fill: "#7986CB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M669.814 97.0696H659.826V98.9521H669.814V97.0696Z",
    fill: "#7986CB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M679.802 101.85H659.826V103.733H679.802V101.85Z",
    fill: "#7986CB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M676.184 106.629H659.826V108.512H676.184V106.629Z",
    fill: "#7986CB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M681.395 111.41H659.826V113.292H681.395V111.41Z",
    fill: "#7986CB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M672.709 116.19H659.826V118.073H672.709V116.19Z",
    fill: "#7986CB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M681.395 120.969H659.826V122.852H681.395V120.969Z",
    fill: "#7986CB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M686.606 126.022H658.812V126.493H686.606V126.022Z",
    fill: "#7986CB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M686.606 82.6436H658.812V83.1145H686.606V82.6436Z",
    fill: "#7986CB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M681.395 129.951H659.826V131.834H681.395V129.951Z",
    fill: "#7986CB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M681.395 132.848H674.157V134.73H681.395V132.848Z",
    fill: "#7986CB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M144.095 44.0497L95.1901 72.3027C88.7516 76.0229 84.7847 82.8977 84.7847 90.3369V146.842C84.7847 154.281 88.7516 161.156 95.1901 164.876L144.095 193.129C150.533 196.849 158.467 196.849 164.906 193.129L213.81 164.876C220.249 161.156 224.216 154.281 224.216 146.842V90.3369C224.216 82.8977 220.249 76.0229 213.81 72.3027L164.906 44.0497C158.467 40.3295 150.533 40.3295 144.095 44.0497Z",
    fill: "#7D8FD8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M147.947 49.1651L97.6922 78.198C93.6369 80.5403 91.1392 84.8698 91.1392 89.5555V147.62C91.1392 152.306 93.6369 156.635 97.6922 158.978L147.947 188.01C152.002 190.353 156.999 190.353 161.053 188.01L211.307 158.978C215.362 156.635 217.86 152.306 217.86 147.62V89.5555C217.86 84.8698 215.362 80.5403 211.307 78.198L161.053 49.1651C156.997 46.8229 152.002 46.8229 147.947 49.1651Z",
    fill: "url(#paint62_linear_1034_134)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M178.952 113.679H109.949C107.737 113.679 105.944 111.885 105.944 109.672C105.944 107.459 107.737 105.665 109.949 105.665H175.274C177.305 105.665 178.952 107.312 178.952 109.345V113.679Z",
    fill: "url(#paint63_linear_1034_134)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M109.745 112.003C108.011 112.003 106.536 110.907 105.96 109.373C105.953 109.472 105.945 109.571 105.945 109.672C105.945 111.884 107.738 113.678 109.95 113.678H178.953V112.003H109.745Z",
    fill: "url(#paint64_linear_1034_134)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M191.055 131.896H114.207V97.9141H191.055V131.896Z",
    fill: "url(#paint65_linear_1034_134)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M183.515 100.192H121.746C121.746 103.1 119.39 105.458 116.482 105.458V124.352C119.389 124.352 121.746 126.709 121.746 129.618H183.515C183.515 126.71 185.871 124.352 188.778 124.352V105.458C185.871 105.458 183.515 103.101 183.515 100.192ZM156.374 126.312C150.078 128.38 143.299 124.95 141.23 118.651C139.164 112.352 142.591 105.568 148.887 103.498C155.182 101.43 161.962 104.86 164.03 111.159C166.097 117.46 162.669 124.243 156.374 126.312Z",
    fill: "url(#paint66_linear_1034_134)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.819 123.121V121.754C150.671 121.62 149.849 121.216 149.354 120.544C148.86 119.872 148.612 118.894 148.612 117.61V117.106H151.801V117.491C151.801 118.433 152.097 118.902 152.69 118.902C152.946 118.902 153.134 118.823 153.254 118.664C153.373 118.505 153.433 118.319 153.433 118.105C153.433 117.726 153.24 117.341 152.855 116.95L150.226 114.3C149.261 113.335 148.777 112.285 148.777 111.155C148.777 110.544 148.917 110.004 149.195 109.537C149.472 109.07 149.842 108.687 150.303 108.391C150.763 108.094 151.269 107.897 151.819 107.799V106.69H153.404V107.772C154.449 107.906 155.243 108.337 155.786 109.065C156.33 109.792 156.602 110.756 156.602 111.953H153.331V111.357C153.331 111.094 153.261 110.893 153.12 110.752C152.98 110.611 152.793 110.541 152.561 110.541C152.305 110.541 152.112 110.605 151.984 110.734C151.855 110.863 151.791 111.033 151.791 111.248C151.791 111.553 152.093 112.005 152.698 112.604L155.265 115.135C155.643 115.507 155.968 115.96 156.241 116.492C156.512 117.024 156.648 117.625 156.648 118.298C156.648 119.307 156.339 120.112 155.723 120.714C155.105 121.316 154.333 121.669 153.404 121.773V123.121H151.819Z",
    fill: "url(#paint67_linear_1034_134)"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M203.056 124.443H126.208V90.4614H203.056V124.443Z",
    fill: "url(#paint68_linear_1034_134)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M195.517 92.7388H133.748C133.748 95.6467 131.392 98.0051 128.484 98.0051V116.899C131.39 116.899 133.748 119.256 133.748 122.165H195.517C195.517 119.257 197.873 116.899 200.78 116.899V98.0051C197.874 98.0051 195.517 95.6467 195.517 92.7388ZM168.376 118.859C162.08 120.927 155.301 117.497 153.232 111.198C151.166 104.899 154.593 98.1148 160.889 96.0453C167.184 93.9772 173.964 97.4071 176.032 103.706C178.099 110.007 174.671 116.791 168.376 118.859Z",
    fill: "url(#paint69_linear_1034_134)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.821 115.667V114.3C162.673 114.166 161.851 113.762 161.355 113.09C160.861 112.418 160.613 111.44 160.613 110.156V109.652H163.802V110.037C163.802 110.979 164.098 111.448 164.691 111.448C164.948 111.448 165.136 111.369 165.255 111.21C165.375 111.051 165.434 110.865 165.434 110.651C165.434 110.272 165.241 109.887 164.857 109.496L162.227 106.846C161.262 105.88 160.779 104.831 160.779 103.701C160.779 103.09 160.918 102.55 161.196 102.083C161.474 101.616 161.843 101.233 162.304 100.937C162.765 100.64 163.27 100.443 163.821 100.345V99.2361H165.406V100.318C166.45 100.452 167.245 100.883 167.788 101.611C168.332 102.338 168.603 103.301 168.603 104.499H165.332V103.903C165.332 103.64 165.263 103.438 165.122 103.298C164.981 103.157 164.794 103.087 164.563 103.087C164.306 103.087 164.113 103.151 163.985 103.28C163.857 103.409 163.792 103.579 163.792 103.794C163.792 104.099 164.095 104.551 164.7 105.15L167.266 107.681C167.644 108.053 167.969 108.505 168.242 109.037C168.514 109.569 168.649 110.171 168.649 110.844C168.649 111.853 168.341 112.658 167.724 113.26C167.107 113.862 166.335 114.215 165.406 114.319V115.667H163.821Z",
    fill: "url(#paint70_linear_1034_134)"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M178.871 113.678H109.95C107.738 113.678 105.945 111.884 105.945 109.672V142.709C105.945 144.922 107.738 146.716 109.95 146.716H178.871C180.902 146.716 182.549 145.069 182.549 143.035V117.359C182.548 115.327 180.902 113.678 178.871 113.678Z",
    fill: "url(#paint71_linear_1034_134)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.871 113.679L178.399 113.664L145.367 146.716H178.871C180.902 146.716 182.549 145.069 182.549 143.035V117.359C182.548 115.327 180.902 113.679 178.871 113.679Z",
    fill: "#5A81E2"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M174.535 135.268H182.326C183.261 135.268 184.019 134.51 184.019 133.574V126.993C184.019 126.058 183.261 125.299 182.326 125.299H174.535C171.783 125.299 169.553 127.53 169.553 130.284C169.553 133.036 171.783 135.268 174.535 135.268Z",
    fill: "url(#paint72_linear_1034_134)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M174.809 133.193C176.415 133.193 177.717 131.89 177.717 130.284C177.717 128.677 176.415 127.375 174.809 127.375C173.204 127.375 171.902 128.677 171.902 130.284C171.902 131.89 173.204 133.193 174.809 133.193Z",
    fill: "url(#paint73_linear_1034_134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_134",
    x1: 301.788,
    y1: 104.111,
    x2: 512.341,
    y2: 314.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1034_134",
    x1: 313.099,
    y1: 295.461,
    x2: 496.546,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3949AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1034_134",
    x1: 296.909,
    y1: 179.09,
    x2: 517.091,
    y2: 179.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1034_134",
    x1: 280.58,
    y1: 217.313,
    x2: 533.42,
    y2: 217.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1034_134",
    x1: 280.58,
    y1: 222.974,
    x2: 533.42,
    y2: 222.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1034_134",
    x1: 280.58,
    y1: 365.683,
    x2: 533.42,
    y2: 365.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1034_134",
    x1: 291.894,
    y1: 229.202,
    x2: 522.107,
    y2: 229.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1034_134",
    x1: 298.119,
    y1: 238.263,
    x2: 336.789,
    y2: 238.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1034_134",
    x1: 298.119,
    y1: 352.66,
    x2: 336.789,
    y2: 352.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1034_134",
    x1: 303.94,
    y1: 295.461,
    x2: 330.967,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1034_134",
    x1: 326.884,
    y1: 71.2036,
    x2: 326.884,
    y2: 242.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1034_134",
    x1: 357.816,
    y1: 238.263,
    x2: 396.486,
    y2: 238.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1034_134",
    x1: 357.816,
    y1: 352.66,
    x2: 396.486,
    y2: 352.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1034_134",
    x1: 363.637,
    y1: 295.461,
    x2: 390.664,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1034_134",
    x1: 386.582,
    y1: 71.2036,
    x2: 386.582,
    y2: 242.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1034_134",
    x1: 417.514,
    y1: 238.263,
    x2: 456.184,
    y2: 238.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1034_134",
    x1: 417.514,
    y1: 352.66,
    x2: 456.184,
    y2: 352.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1034_134",
    x1: 423.335,
    y1: 295.461,
    x2: 450.363,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1034_134",
    x1: 446.279,
    y1: 71.2036,
    x2: 446.279,
    y2: 242.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1034_134",
    x1: 477.211,
    y1: 238.263,
    x2: 515.881,
    y2: 238.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1034_134",
    x1: 477.211,
    y1: 352.66,
    x2: 515.881,
    y2: 352.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1034_134",
    x1: 483.033,
    y1: 295.461,
    x2: 510.06,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1034_134",
    x1: 505.977,
    y1: 71.2036,
    x2: 505.977,
    y2: 242.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1034_134",
    x1: 344.348,
    y1: 180.2,
    x2: 469.651,
    y2: 180.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1034_134",
    x1: 344.348,
    y1: 197.442,
    x2: 469.651,
    y2: 197.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1034_134",
    x1: 610.596,
    y1: 331.738,
    x2: 708.462,
    y2: 429.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1034_134",
    x1: 645.813,
    y1: 397.734,
    x2: 697.506,
    y2: 397.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1034_134",
    x1: 658.471,
    y1: 380.129,
    x2: 684.865,
    y2: 406.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1034_134",
    x1: 645.813,
    y1: 386.421,
    x2: 697.506,
    y2: 386.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1034_134",
    x1: 658.471,
    y1: 368.816,
    x2: 684.865,
    y2: 395.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1034_134",
    x1: 645.813,
    y1: 375.108,
    x2: 697.506,
    y2: 375.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1034_134",
    x1: 658.471,
    y1: 357.503,
    x2: 684.865,
    y2: 383.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1034_134",
    x1: 645.813,
    y1: 363.795,
    x2: 697.506,
    y2: 363.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1034_134",
    x1: 658.471,
    y1: 346.19,
    x2: 684.865,
    y2: 372.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1034_134",
    x1: 645.813,
    y1: 352.482,
    x2: 697.506,
    y2: 352.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1034_134",
    x1: 658.471,
    y1: 334.877,
    x2: 684.865,
    y2: 361.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1034_134",
    x1: 664.914,
    y1: 406.373,
    x2: 604.29,
    y2: 345.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD54F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1034_134",
    x1: 664.915,
    y1: 406.373,
    x2: 631.872,
    y2: 373.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD54F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1034_134",
    x1: 637.092,
    y1: 378.516,
    x2: 654.527,
    y2: 395.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1034_134",
    x1: 105.597,
    y1: 331.738,
    x2: 203.463,
    y2: 429.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1034_134",
    x1: 105.599,
    y1: 364.352,
    x2: 177.961,
    y2: 407.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3949AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1034_134",
    x1: 130.72,
    y1: 406.593,
    x2: 130.72,
    y2: 364.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0889,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5361,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1034_134",
    x1: 112.744,
    y1: 377.897,
    x2: 123.398,
    y2: 377.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EAF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1034_134",
    x1: 133.437,
    y1: 355.067,
    x2: 205.798,
    y2: 398.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1034_134",
    x1: 158.558,
    y1: 397.308,
    x2: 158.558,
    y2: 354.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0889,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5361,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1034_134",
    x1: 140.581,
    y1: 368.611,
    x2: 151.235,
    y2: 368.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EAF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1034_134",
    x1: 29.8191,
    y1: 200.405,
    x2: 127.685,
    y2: 298.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1034_134",
    x1: 58.888,
    y1: 249.338,
    x2: 98.5558,
    y2: 249.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1034_134",
    x1: 58.888,
    y1: 272.668,
    x2: 98.5558,
    y2: 272.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1034_134",
    x1: 58.888,
    y1: 225.663,
    x2: 98.5558,
    y2: 225.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1034_134",
    x1: 60.4514,
    y1: 237.403,
    x2: 91.806,
    y2: 237.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1034_134",
    x1: 56.9319,
    y1: 215.675,
    x2: 100.511,
    y2: 215.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1034_134",
    x1: 56.9319,
    y1: 283,
    x2: 100.511,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1034_134",
    x1: 686.375,
    y1: 200.405,
    x2: 784.241,
    y2: 298.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1034_134",
    x1: 723.591,
    y1: 214.68,
    x2: 746.979,
    y2: 238.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1034_134",
    x1: 710.322,
    y1: 233.88,
    x2: 760.263,
    y2: 283.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1034_134",
    x1: 753.992,
    y1: 288.364,
    x2: 753.992,
    y2: 232.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1034_134",
    x1: 610.596,
    y1: 69.6555,
    x2: 708.462,
    y2: 167.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1034_134",
    x1: 623.524,
    y1: 100.047,
    x2: 679.985,
    y2: 156.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1034_134",
    x1: 627.16,
    y1: 103.685,
    x2: 676.345,
    y2: 152.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3949AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1034_134",
    x1: 641.304,
    y1: 146.141,
    x2: 662.184,
    y2: 167.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1034_134",
    x1: 672.71,
    y1: 137.075,
    x2: 672.71,
    y2: 71.8247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1034_134",
    x1: 105.597,
    y1: 69.6555,
    x2: 203.463,
    y2: 167.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1034_134",
    x1: 108.139,
    y1: 109.672,
    x2: 324.568,
    y2: 109.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1034_134",
    x1: 105.945,
    y1: 111.526,
    x2: 178.952,
    y2: 111.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6BC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1034_134",
    x1: 114.207,
    y1: 114.905,
    x2: 191.054,
    y2: 114.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1034_134",
    x1: 116.482,
    y1: 114.905,
    x2: 188.778,
    y2: 114.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1034_134",
    x1: 188.72,
    y1: 114.905,
    x2: 116.861,
    y2: 114.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1034_134",
    x1: 126.208,
    y1: 107.452,
    x2: 203.055,
    y2: 107.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1034_134",
    x1: 128.484,
    y1: 107.452,
    x2: 200.78,
    y2: 107.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1034_134",
    x1: 200.722,
    y1: 107.452,
    x2: 128.862,
    y2: 107.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1034_134",
    x1: 105.945,
    y1: 128.194,
    x2: 182.548,
    y2: 128.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3949AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1034_134",
    x1: 169.553,
    y1: 130.283,
    x2: 184.019,
    y2: 130.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1034_134",
    x1: 172.753,
    y1: 128.226,
    x2: 176.868,
    y2: 132.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3949AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialBank);
export default __webpack_public_path__ + "static/media/Commercial-Bank.838dff059f66d7165726c1cda23ef54c.svg";
export { ForwardRef as ReactComponent };